import React from 'react';
import styles from './Shared.module.css';

function MetricsCard({ value, subtext }) {
  return (
    <div className={styles.systemMetricsCard}>
      <p className={styles.systemMetricsCardValue}>{value}</p>
      <p className={styles.systemMetricsCardExplainer}>{subtext}</p>
    </div>
  );
}

export default MetricsCard;
